import React from 'react';
import styled from 'styled-components';
import {rgba} from 'polished';

import PageContainer from 'components/common/PageContainer';
import AppPageHeader from 'components/common/AppPageHeader';
import ContainerHeader from 'components/common/ContainerHeader';

import {colors, containerStyles} from 'styles/shared';

const CONTAINER_WIDTH = 114;

const ImageContainer = styled.div`
  max-width: ${CONTAINER_WIDTH}rem;
  height: 25.1rem;
  background: url(/images/about-bg.svg) no-repeat;
  margin-bottom: 5rem;
`;

const AboutTravelApiContainer = styled.div`
  width: ${CONTAINER_WIDTH}rem;
  height: 54.6rem;
  padding: 4.5rem 5rem 5rem;
  margin-bottom: 10rem;
  ${containerStyles};

  @media (max-width: 1440px) {
    height: auto;
    width: auto;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3.3rem;

  @media (max-width: 1440px) {
    flex-direction: column;
  }
`;

const TextContainer = styled.div`
  width: 44.5rem;
  font-size: 1.8rem;
  line-height: 2.7rem;
  color: ${colors.darkBlue_main};
`;

const BodyTitle = styled.div`
  font-size: 2.1rem;
  line-height: 3.1rem;
  color: ${colors.blue_darker};
  margin-bottom: 3rem;
`;

const Devider = styled.div`
  width: 0.2rem;
  height: 37.9rem;
  background: ${rgba(colors.darkBlue_lighter, 0.3)};

  @media (max-width: 1440px) {
    display: none;
  }
`;

function AboutPage() {
  return (
    <PageContainer>
      <AppPageHeader title="About" />

      <ImageContainer />

      <AboutTravelApiContainer>
        <ContainerHeader>About the Travel Advice API</ContainerHeader>

        <BodyContainer>
          <TextContainer>
            <BodyTitle>
                Travelling now is complicated. In response to the Coronavirus, governments around the world are adjusting their
              travel and social policies to try to keep the virus at bay.
            </BodyTitle>
            Many people want to travel, but don’t know the latest requirements and situation at their destination.
            They have to search themselves to make their decisions or spend time on calls with travel agents.
          </TextContainer>

          <Devider />

          <TextContainer>
              Give your customers access to this information through updates sent straight to their inbox and through integration in to your platform.
              <br /><br />
              API data sourced from various government websites, Our World In Data and OxCGRT Policy Tracker (Thomas Hale, Sam Webster, Anna Petherick, Toby Phillips, and Beatriz Kira.
              (2020). Oxford COVID-19 Government Response Tracker. Blavatnik School of Government.)
          </TextContainer>
        </BodyContainer>
      </AboutTravelApiContainer>
    </PageContainer>
  );
}

export default AboutPage;
